export const getTopScorers = (assignmentMarks, quizMarks, students) => {
    if (assignmentMarks && quizMarks && students) {
      const result = [];
      
      // combine assignment marks and quiz marks for each student
      const marks = {};
  
      assignmentMarks.forEach((assignment) => {
        const { student_id, student_name, mark, totalMark } = assignment;
        if (!marks[student_id]) {
          marks[student_id] = {
            id: student_id,
            name: student_name,
            totalQuizMark: 0,
            totalAssignmentMark: 0,
          };
        }
        marks[student_id].totalAssignmentMark += mark;
      });
  
      quizMarks.forEach((quiz) => {
        const { student_id, student_name, totalMark } = quiz;
        if (!marks[student_id]) {
          marks[student_id] = {
            id: student_id,
            name: student_name,
            totalQuizMark: 0,
            totalAssignmentMark: 0,
          };
        }
        marks[student_id].totalQuizMark += totalMark;
      });
  
      // calculate total marks and add to result array
      for (const student of Object.values(marks)) {
        const { id, name, totalQuizMark, totalAssignmentMark } = student;
        const totalMark = totalQuizMark + totalAssignmentMark;
        result.push({ id, name, totalQuizMark, totalAssignmentMark, totalMark });
      }
  
       // assign ranks to each student based on their total marks
       result.sort((a, b) => b.totalMark - a.totalMark);
       let rank = 1;
       for (let i = 0; i < result.length; i++) {
           const currentStudent = result[i];
           const prevStudent = result[i-1];

           if (prevStudent && prevStudent.totalMark === currentStudent.totalMark) {
               // set rank equal to the previous student's rank
               currentStudent.rank = prevStudent.rank;
           } else {
               // set the rank to the current value of `rank` and update it
               currentStudent.rank = rank;
               rank += 1;
           }
       }
  
      // move students with zero marks to the end of the list
      let nonZeroStudents = result.filter((student) => student.totalMark > 0);
      let zeroStudents = result.filter((student) => student.totalMark === 0);
      let finalResult = nonZeroStudents.concat(zeroStudents);
  
      // add any students not already in the result array
      for (const student of students) {
        const { id, name } = student;
        const alreadyExists = finalResult.some((s) => s.id === id);
        if (!alreadyExists) {
          finalResult.push({ id, name, totalQuizMark: 0, totalAssignmentMark: 0, totalMark: 0, rank: 'N/A' });
        }
      }
      return finalResult;
    }
  };